import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useHistory } from 'react-router-dom';
import { Column, Row, Button, Flex } from '@grubhubprod/gh-cookbook-react';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';
import { getWindow } from 'src/utilities/window';
import { RouterButtonLink } from 'src/components/RouterLink/RouterButtonLink';
import {
  buildCAUIUrl,
  buildCMUIPath,
  CAUIPage,
  CMUIPage,
} from 'src/constants/urls';
import { useEmployeeListFeatureAccess } from 'src/components/enterprise/features/Employee/Routes/useEmployeeListFeatureAccess/useEmployeeListFeatureAccess';

type EmployeeFormFooterProps = {
  onSubmit: (data: EmployeeFormFields) => void;
};

export const EmployeeFormFooter: React.FC<EmployeeFormFooterProps> = ({
  onSubmit,
}) => {
  const { handleSubmit, formState } = useFormContext<EmployeeFormFields>();
  const { isValid, isSubmitting } = formState;
  const { isEditPage, corpId, employeeId } = useEmployeeFormContext();
  const { canAccessEmployeeList } = useEmployeeListFeatureAccess();
  const { push } = useHistory();
  const window = getWindow();

  const renderButtonText = (): string => {
    if (isEditPage) {
      return 'Save Changes';
    }
    return 'Add New Employee';
  };

  const handleCancel = (): void => {
    if (canAccessEmployeeList) {
      push(buildCMUIPath(CMUIPage.EMPLOYEES, { corpId }));
    } else {
      window.location.href = buildCAUIUrl(CAUIPage.EMPLOYEES, {
        corpId,
      });
    }
  };

  return (
    <Row gutter={8}>
      <Column gutter={8} phone={3}>
        <Button
          block
          type="button"
          isLoading={isSubmitting}
          disabled={!isValid || isSubmitting}
          variant="primary"
          buttonSize="medium"
          onClick={handleSubmit(onSubmit)}
        >
          {renderButtonText()}
        </Button>
      </Column>
      <Column gutter={8} phone={3}>
        {isEditPage ? (
          <RouterButtonLink
            href={buildCMUIPath(CMUIPage.EMPLOYEE_DETAILS, {
              corpId,
              employeeId,
            })}
            buttonVariant="secondary"
            buttonSize="medium"
            useBlockButton
          >
            <Flex width="100%" alignItems="center" justifyContent="center">
              Cancel
            </Flex>
          </RouterButtonLink>
        ) : (
          <Button
            block
            type="button"
            variant="secondary"
            buttonSize="medium"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        )}
      </Column>
    </Row>
  );
};
